import { render, staticRenderFns } from "./PermissionRequestList.vue?vue&type=template&id=9fd0a948"
import script from "./PermissionRequestList.js?vue&type=script&lang=js&external"
export * from "./PermissionRequestList.js?vue&type=script&lang=js&external"
import style0 from "./PermissionRequestList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports